import React, { useEffect } from 'react';
import classNames from 'classnames';
import iconSelect from '../icons/tool_select.png';
import iconWrite from '../icons/tool_write.png';
import iconPaint from '../icons/tool_paint.png';
import iconErase from '../icons/tool_erase.png';
import iconKeyInput from '../icons/tool_keyInput.png';
import iconStairs from '../icons/tool_stairs.png';
import iconMonoStairs from '../icons/tool_monoStairs.png';
import iconTrill from '../icons/tool_trill.png';
import iconPattern from '../icons/tool_pattern.png';
import { Tool } from '../store/types';
import { SequenceContainer } from '../store/SequenceContainer';

interface ToolIcon {
  enabled: boolean;
  icon: string;
  label: string;
}

const icons: ToolIcon[] = [
  { enabled: false, icon: iconSelect, label: "選択ツール" },
  { enabled: false, icon: iconWrite, label: "鉛筆ツール" },
  { enabled: true, icon: iconPaint, label: "ペイントツール" },
  { enabled: false, icon: iconErase, label: "消しゴムツール" },
  { enabled: false, icon: iconKeyInput, label: "キー入力ツール" },
  { enabled: true, icon: iconStairs, label: "階段ツール" },
  { enabled: true, icon: iconMonoStairs, label: "同色階段ツール" },
  { enabled: true, icon: iconTrill, label: "トリルツール" },
  { enabled: false, icon: iconPattern, label: "パターンツール" },
];

function createTool(icon: ToolIcon, tool: Tool, selected: boolean,
  setSelectedTool: (value: number) => void) {

  return (
    <li className={classNames(
      selected ? 'selected' : '',
      icon.enabled ? '' : 'disabled'
    )}
      key={tool} onClick={() => setSelectedTool(tool)}
    >
      <img src={icon.icon} alt={icon.label} />
    </li>
  );
}

const KEYCODE_1 = 49;

export const ToolBar: React.FC = props => {
  const { edit, clearAll, clearKey } = SequenceContainer.useContainer();

  // 数字キーでツールを選択
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      const i = e.keyCode - KEYCODE_1;
      if (0 <= i && i <= Tool.Pattern) {
        edit.setSelectedTool(i);
        e.stopPropagation();
        e.preventDefault();
      }
    }
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [edit]);

  const vz = edit.verticalZoom;

  return (
    <div className="ToolBar">
      <ul className="tools">
        {icons.map((icon, tool) => createTool(icon, tool, tool === edit.selectedTool, edit.setSelectedTool))}
      </ul>
      <div className="buttons">
        Zoom: x{Math.floor(vz)}.{Math.floor(vz * 10 % 10)}{Math.floor(vz * 100 % 10)}
        <input type="range" value={edit.verticalZoom} min="0.25" max="5" step="0.25" style={{ position: 'absolute', left: 90, top: 7 }}
          onChange={e => edit.setVerticalZoom(Number.parseFloat(e.currentTarget.value))}></input>
        <span style={{ position: 'absolute', left: 300, top: 0, width: 200 }}>
          <button onClick={() => clearKey()}>Clear Key</button>
          <button onClick={() => clearAll()}>Clear All</button>
        </span>
      </div>
    </div>
  );
};
